import classNames from 'clsx';
import { useSelector } from 'react-redux';

import Slider from '@swf/components/Slider/Slider';
import { select } from '@swf/core/store';

import type { Tournament } from '../../types/MTT';

import HighlightsItem from './HighlightsItem/HighlightsItem';
import styles from './HighlightsSection.scss';

interface HighlightsSectionProps {
  highlightTournaments: Tournament[];
}

const HighlightsSection: React.FC<HighlightsSectionProps> = ({ highlightTournaments }) => {
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);

  return (
    <div
      className={classNames(styles.highlightSection, {
        [styles.sticky]: isDesktopEmbedded
      })}
    >
      <Slider innerClassName={styles.slider}>
        {highlightTournaments.map((tournament) => (
          <HighlightsItem key={tournament.id} tournament={tournament} />
        ))}
      </Slider>
    </div>
  );
};

export default HighlightsSection;
